import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box'; // Imported Box for consistent modern enterprise layout tracking
import { Link } from 'react-router-dom';
import { useraccountactivate, resetOnboarding } from '../../pages/Dashboard/onboardingSlice';
import { authenticate } from '../../pages/Auth/authSlice';
import { fetchProfile } from '../Settings/Profile/profileSlice';

const Header = ({ }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth.profile); 
    const profileData = useSelector(state => state.profile.profile);
    const activation = useSelector(state => state.onboarding && state.onboarding.activation);  
    const [alert, setAlert] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const handleClose = () => {
        setSnackOpen(false);
        dispatch(resetOnboarding());
    };
    const handleVerify = () => {
        dispatch(useraccountactivate())
    }
    useEffect(() => {
        if (activation && activation.message && activation.hasErrors == false ) {
            setAlert(true)
            setSnackOpen(true)            
        } else if (activation && activation.hasErrors == true) {
            setAlert(true)
            setSnackOpen(true)
        }
    }, [activation && activation.message])

    // useEffect(() => {
    //         dispatch(fetchProfile())
    // }, [dispatch]);

    return (
        <>
            {alert &&
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert severity={activation && activation.hasErrors === true ? "error" : "success"}
                        sx={{ 
                            justifyContent: 'center', 
                            margin: "10px 0",
                            borderRadius: '12px',
                            fontWeight: 600,
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <span > {activation && activation.message}</span>
                    </Alert>
                </Snackbar>
            }
                    
            {/* ─── WORKSPACE ALIGNMENT LAYER ───
              Using an unstyled outer block element to consume and insulate from the parent Stack's 'margin: 0' custom rule.
              Inside it, we utilize a flexible centered container layout.
            */}
            <div> 
                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', // Centers the item horizontally inside the header wrapper layout
                        width: '100%',
                        maxWidth: '600px',        // Enterprise layout standard width container mapping
                        mx: 'auto !important',    // High specificity bypass reinforcement to counter baseline overrides
                        my: '10px'                // Provides clean uniform vertical alignment spacing
                    }}
                >
                    {profileData && profileData.status === 'PENDING' && profileData.id === 94 &&
                        typeof profileData.is_user_form_verfication_status !== 'undefined' &&
                        (profileData.verification_status !== "VERIFIED" || profileData.verification_status === null) && (
                            <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#FFFBEB", // Enterprise soft warm amber tone
                                    color: "#78350F",           // Luxury corporate text color
                                    border: '1px solid #FEF3C7',
                                    borderRadius: '12px',
                                    fontWeight: 600,
                                    fontSize: '13.5px',
                                    display: 'flex',
                                    alignItems: 'center',       
                                    width: '100%',
                                    py: 1,
                                    height: '50px',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
                                    '& .MuiAlert-icon': { color: '#D97706 !important', display: 'flex', alignItems: 'center' }
                                }}
                                >
                                <p style={{ margin: 0 }}>
                                    We are currently processing your business verification. Please wait for further updates.
                                </p>
                            </Alert>
                        )
                    }

                    {profileData && profileData.status === 'PENDING' &&
                        profileData.activation_requested === true &&
                        ((profileData.verification_status === "VERIFIED" && profileData.id === 94) || profileData.id !== 94) && (
                                <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#FFFBEB", // Enterprise soft warm amber tone
                                    color: "#78350F",           // Luxury corporate text color
                                    border: '1px solid #FEF3C7',
                                    borderRadius: '12px',
                                    fontWeight: 600,
                                    fontSize: '13.5px',
                                    display: 'flex',
                                    alignItems: 'center',       
                                    width: '100%',
                                    py: 1,
                                    height: '50px',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
                                    '& .MuiAlert-icon': { color: '#D97706 !important', display: 'flex', alignItems: 'center' }
                                }}
                                >
                                <p style={{ margin: 0 }}>
                                    Your account is on verifying process yet to be activated
                                </p>
                            </Alert>
                        )
                    }

                    {profileData && profileData.status === 'PENDING' &&
                        profileData.activation_requested === false &&
                        ((profileData.verification_status === "VERIFIED" && profileData.id === 94) || profileData.id !== 94) && (
                            <>
                                <Alert
                                severity="warning"
                                sx={{
                                    backgroundColor: "#FFECE5", // Modern soft accent coral-orange tone
                                    color: "#9A3412",           // High contrast readable dark text
                                    border: '1px solid #FDBA74',
                                    borderRadius: '12px',
                                    fontWeight: 600,
                                    fontSize: '13.5px',
                                    display: 'flex',
                                    alignItems: 'center',       
                                    width: '100%',
                                    py: 1,
                                    height: '50px',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
                                    '& .MuiAlert-icon': { color: '#EA580C !important', display: 'flex', alignItems: 'center' }
                                }}
                                >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                    <p style={{ margin: 0, fontWeight: 600 }}>
                                        Add a valid payment method to continue printing labels.
                                    </p>
                                    <Link to="/settings/payment" style={{ textDecoration: 'none' }}>
                                        <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            color: '#9A3412',
                                            borderColor: '#FDBA74',
                                            fontWeight: 700,
                                            fontSize: '12px',
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            marginLeft: '16px',
                                            backgroundColor: '#FFFFFF',
                                            height: '28px',
                                            '&:hover': {
                                                borderColor: '#EA580C',
                                                backgroundColor: '#FFF7ED'
                                            }
                                        }}
                                        >
                                        Add credit card
                                        </Button>
                                    </Link>
                                </div>
                                </Alert>
                            </>
                        )
                    }
                </Box>
            </div>
                    
        </>
    )

}

export default Header;